
import { appDependencies } from "../AppDependencies";
import { ValidationError, ValidationResult } from "../app/ValidationError";
import { IAttentionDay } from "./IAttentionDay";
import { IAttentionDayService } from "./IAttentionDayService";

export class AttentionDayService implements IAttentionDayService {

    requestById(id: string): Promise<IAttentionDay> {
        return appDependencies.IAttentionDayRepository.getById(id);
    }
    requestAttentionDays(): Promise<IAttentionDay[]> {
        return appDependencies.IAttentionDayRepository.getAttentionDays();
    }
    requestCreateAttentionDay(attentionDay: IAttentionDay): Promise<IAttentionDay> {
        return appDependencies.IAttentionDayRepository.createAttentionDay(attentionDay);
    }
    async requestUpdateAttentionDay(attentionDay: IAttentionDay): Promise<IAttentionDay> {
        if (attentionDay.start > attentionDay.end) {
            throw new ValidationError([new ValidationResult("", "validation.failed.start-smaller-end")])
        }

        return await appDependencies.IAttentionDayRepository.updateAttentionDay(attentionDay);
    }
    requestDeleteAttentionDay(attentionDay: IAttentionDay): Promise<IAttentionDay> {
        return appDependencies.IAttentionDayRepository.deleteAttentionDay(attentionDay);
    }
    importAttentionDays(): Promise<any> {
        return appDependencies.IAttentionDayRepository.importAttentionDays();
    }
}
